import axios from 'axios'
import * as user from './user'
import { Message } from 'element-ui'
import store from '@/store' // 引入 Vuex store 实例

// 创建基础实例
const api = axios.create({
  baseURL: 'https://www.hittik.com'
    // baseURL: 'http://192.168.80.81:8080'
})

// 请求拦截器
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器
api.interceptors.response.use(
  response => {
    const res = response.data;
    console.log(res);
    
    if (res.code === 200) {
      return res.data // 正常返回数据
    } else if (res.code === 401) {
      Message({
        message: '登录已过期，请重新登录',
        type: 'error',
        duration: 1500
      })
      
      // 清除用户相关数据
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('phonedigits');
      
      // 使用 store 实例直接提交 mutation
      store.commit("setDialogVisible", true);
      store.commit("setUseisRegister", false);
      
      // 返回一个 reject 的 Promise 阻止后续处理
      return Promise.reject(new Error('登录已过期'))
    } else {
      Message({
        message: res.msg || '操作失败',
        type: 'error',
      })
      return Promise.reject(new Error(res.msg || 'Error'))
    }
  },
  error => {
    // 处理网络错误
    Message({
      message: error.response?.data?.msg || error.message || '请求异常',
      type: 'error',
    })
    return Promise.reject(error)
  }
)

// 绑定模块方法
const API = {
  ...user,
  get: api.get,
  post: api.post,
  put: api.put,
  delete: api.delete
}

// 自动绑定 this 上下文
const boundAPI = {}
Object.entries(API).forEach(([key, value]) => {
  boundAPI[key] = typeof value === 'function' ? value.bind(api) : value
})

export default boundAPI